import { render } from "./LoadingDots.vue?vue&type=template&id=8105327e&scoped=true"
import script from "./LoadingDots.vue?vue&type=script&lang=js"
export * from "./LoadingDots.vue?vue&type=script&lang=js"

import "./LoadingDots.vue?vue&type=style&index=0&id=8105327e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8105327e"]])

export default __exports__